import { render, staticRenderFns } from "./PocketDetailsView.vue?vue&type=template&id=cc4604b2&scoped=true"
import script from "./PocketDetailsView.vue?vue&type=script&lang=js"
export * from "./PocketDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4604b2",
  null
  
)

export default component.exports